import { useTranslation } from 'react-i18next';

import aws from '@/assets/logos/aws.png';
import azure from '@/assets/logos/azure.png';
import flutter from '@/assets/logos/flutter.png';
import google from '@/assets/logos/google.png';
import microsoft from '@/assets/logos/microsoft.png';
import netCore from '@/assets/logos/net-core.png';
import openAi from '@/assets/logos/open-ai.png';
import oracle from '@/assets/logos/oracle.png';
import reactNative from '@/assets/logos/react-native.png';

export const TechnologiesSection = () => {
  const { t } = useTranslation('home');

  const logos = [
    { src: microsoft, alt: 'Microsoft', height: 'h-16' },
    { src: google, alt: 'Google', height: 'h-16' },
    { src: oracle, alt: 'Oracle', height: 'h-8' },
    { src: reactNative, alt: 'React Native', height: 'h-16' },
    { src: flutter, alt: 'Flutter', height: 'h-16' },
    { src: netCore, alt: '.NET Core', height: 'h-16' },
    { src: azure, alt: 'Azure', height: 'h-16' },
    { src: aws, alt: 'AWS', height: 'h-16' },
    { src: openAi, alt: 'OpenAI', height: 'h-16' },
  ];

  return (
    <div className="section !px-0 overflow-hidden">
      <div className="flex justify-center items-center">
        <div className="section-title px-4">
          <h1>{t('technologiesTitle')}</h1>
        </div>
      </div>

      <div className="relative w-full overflow-hidden mt-8">
        <div className="animate-marquee flex items-center w-max">
          {[...logos, ...logos].map((logo, index) => (
            <img
              key={index}
              src={logo.src}
              alt={logo.alt}
              className={`my-4 mx-12 ${logo.height}`}
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </div>
  );
};
